import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import Menu from '@/global/components/MenuV2'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import ContentGuide from 'global/guides/ContentGuide'
import { ListIcon } from 'lucide-react'
import { Outlet, useParams } from 'react-router-dom'
import { Funcionario, empresas as empresasApi } from 'service/api'
import { columnsFuncionarios as columns } from 'templates/Cadastro/Funcionarios/constants/columns'

export default function FuncionariosEmpresaCliente() {
    const { clienteId, empresaId } = useParams()

    const { data: empresas } = empresasApi.useFetch({
        queryParams: { clienteId },
        enabled: !!clienteId,
    })

    const { data, isLoading } = empresasApi.useFetchByIdFrom<Funcionario[]>(
        empresaId!,
        'funcionarios',
        {
            enabled: !!empresaId,
        },
    )

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={[
                        'Administração',
                        { title: 'Clientes', to: '/administracao/clientes' },
                        {
                            title: 'Empresas',
                            to: `/administracao/clientes/${clienteId}/empresas`,
                        },
                        'Funcionários',
                    ]}
                >
                    <Box width={400}>
                        <FormControl size="small" fullWidth variant="filled">
                            <InputLabel id="empresas-select-label">
                                Empresas
                            </InputLabel>
                            <Select
                                labelId="empresas-select-label"
                                id="empresas-select"
                                defaultValue={empresaId}
                                label="Empresas"
                                MenuProps={{
                                    anchorPosition: { top: 0, left: 0 },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'center',
                                    },
                                    sx: {
                                        maxHeight: `calc(100vh - 20rem)`,
                                        width: 400,
                                    },
                                }}
                            >
                                {empresas?.map(({ id, nomeFantasia }) => (
                                    <Menu.Item
                                        key={id}
                                        value={id}
                                        href={`/administracao/clientes/${clienteId}/empresas/${id}/funcionarios`}
                                    >
                                        {nomeFantasia}
                                    </Menu.Item>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    columns={[
                        ...columns,
                        {
                            ...optionsColumn,
                            field: '__opcoes',
                            renderCell: ({ id }) => (
                                <IconButton
                                    href={`${id}/detalhes`}
                                    title="Detalhes"
                                >
                                    <ListIcon />
                                </IconButton>
                            ),
                        },
                    ]}
                    rows={data}
                    loading={isLoading}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-funcionarios',
                        },
                    }}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}
